
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Cover2206545806",
      {"classes":{"root":"Cover2206545806__root","cover":"Cover2206545806__cover"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  